<script setup lang="ts">
interface Props {
  duration?: number
}
const { duration: durationProp = 500 } = defineProps<Props>()

const duration = computed(() => `${durationProp}ms`)

function enter(element: Element) {
  if (!(element instanceof HTMLElement))
    return

  const width = getComputedStyle(element).width

  element.style.width = width
  element.style.position = 'absolute'
  element.style.visibility = 'hidden'
  element.style.height = 'auto'

  const height = getComputedStyle(element).height

  element.style.width = ''
  element.style.position = ''
  element.style.visibility = ''
  element.style.height = '0'

  // INFO: Forcing the browser to repaint the element
  // eslint-disable-next-line no-unused-expressions
  getComputedStyle(element).height

  requestAnimationFrame(() => {
    element.style.height = height
  })
}

function afterEnter(element: Element) {
  if (!(element instanceof HTMLElement))
    return

  element.style.height = 'auto'
}

function leave(element: Element) {
  if (!(element instanceof HTMLElement))
    return

  const height = getComputedStyle(element).height
  element.style.height = height

  // INFO: Forcing the browser to repaint the element
  // eslint-disable-next-line no-unused-expressions
  getComputedStyle(element).height

  requestAnimationFrame(() => {
    element.style.height = '0'
  })
}
</script>

<template>
  <Transition
    name="collapse"
    @enter="enter"
    @after-enter="afterEnter"
    @leave="leave"
  >
    <slot />
  </Transition>
</template>

<style>
.collapse-enter-active,
.collapse-leave-active {
  transition: height v-bind('duration') ease-in-out;
  overflow: hidden;
}

.collapse-enter,
.collapse-leave-to {
  height: 0;
}
</style>

<style scoped>
* {
  will-change: height;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
}
</style>
